export class KycUploadReq {
    kycDetails: KycDetailsLog;
    kycDocUploadDetails: KycDocUploadDtls[] = [];
}

/*export class KycDetailsLog {
    id: number;
    policyNo: string = "P0129329384";
    quoteNo: string = "Q12029302";
    inwardNo: string = "I1029393839";
    createdBy: string = "Admin";
    appName: string = "iLounge";
    proposalNo:string = "29382983";
    product:string = "Life Line";
    lob:string = "Health"
    customerName:string = "Customer";
    mobileNo:string = "9999999999";
    emailId:string = "test@test.com";
    address1:string = "Chennai";
    address2:string = "Chennai";
    address3:string = "Chennai";
    address4:string = "Chennai";
    state: string = "TN";
    city:string = "Chennai";
    pinCode:string = "010101";
    ckycNo:string = "010920";
    panNumber:string = "ABCKD0101A";
    dateOfBirth:string = "01/01/1990";
    eiaNumber:string = "AL0198339";
    customerType:string = "CUST";
    backURL: string;
}*/

export class KycDetailsLog {
    id: number;
    policyNo: string;
    quoteNo: string;
    inwardNo: string;
    createdBy: string;
    appName: string;
    proposalNo:string;
    product:string;
    lob:string
    customerName:string;
    mobileNo:string;
    emailId:string;
    address1:string;
    address2:string;
    address3:string;
    address4:string;
    state: string;
    city:string;
    pinCode:string;
    ckycNo:string;
    panNumber:string;
    dateOfBirth:string;
    eiaNumber:string;
    customerType:string;
    returnURL: string;
    firstName: string;
    middleName: string;
    lastName: string;
    district: string;
    country: string;
    aadharNumber: string;
    userName: string;
    kycStatus: string;
}

export class KycDocUploadDtls {
    kycProofType: string = "";
    kycDocType: string = "";
    kycDocDetail: KycDocDetails[] = [];
}

export class KycDocDetails {
    kycDocName: string;
    kycDoc: string;
}

export class KycUploadRes {
    successMsg: string;
    errMsg: string;
    kycDetails: KycDetailsLog;
    kycDocUploadDetails: KycDocUploadDtls[] = [];
}